import React, { useEffect, useState } from "react";
import { FaBold, FaItalic, FaFont, FaCode, FaFeatherAlt } from "react-icons/fa";
import { GiSpikedDragonHead, GiPerspectiveDiceSixFacesRandom } from "react-icons/gi";
// import { GiFractalCrystal } from "react-icons/gi";

import "./SelectBox.css";
import { trackEvent } from "./UtilsFunction";
import { toast } from "react-toastify";

const styleList = [
  { label: "Bold (Sans)", value: "boldSans", icon: <FaFont /> },
  { label: "Bold Italic", value: "boldItalic", icon: <FaItalic /> },
  
  
  { label: "Script", value: "script", icon: <FaFeatherAlt /> },
  { label: "Fraktur", value: "fraktur", icon: <GiSpikedDragonHead /> },
  { label: "Double Struck", value: "doubleStruck", icon: <GiPerspectiveDiceSixFacesRandom /> },
  { label: "Monospace", value: "monospace", icon: <FaCode /> },
  
  { label: "Bold (Serif)", value: "boldSerif", icon: <FaBold /> },
  { label: "Italic", value: "italic", icon: <FaItalic /> },
];

const CustomFontSelector = ({ selected, onSelect, hasText  }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if(document.querySelector('.active-f')) {
        document.querySelector('.selected_correct_icon')?.remove()
      document.querySelector('.active-f').innerHTML += `<i class="fa-solid fa-check selected_correct_icon"></i>`;
    }
  })

//   const handleFontSelect = (style) => {
//     if (selected?.value === style.value) return;
//     console.log("apply_font")
//   trackEvent("font_style_selected", {
//     font_style: style.value,
//     font_label: style.label,
//   });

//   onSelect(style);
// };

const handleFontSelect = (style, index) => {
  // Disable all styles except the first one when there is no text
  // if (!hasText && index !== 0) {
  //   // Show toast
  //   // Replace this with your project's toast function

  //     trackEvent("no_input_text_apply_font", {
  //   font_style: style.value,
  //   font_label: style.label,
  //   from: window.location.pathname,
    
  // });
  //   toast.info("Select or type a caption to apply a font")

  //   return;
  // }

  if (selected?.value === style.value) return;

  console.log("apply_font");

  trackEvent("font_style_selected", {
    font_style: style.value,
    font_label: style.label,
    from: window.location.pathname,
    
  });

  onSelect(style);
};

  return (
    <div className="custom-select-box">
      {/* <div className="selected-option" onClick={() => setOpen(!open)}>
        <span className="icon">{selected.icon|| styleList[0].icon}</span>
        <span>{selected.label}</span>
        <span className="arrow">{open ? <i class="fa-solid fa-angle-up"></i> : <i class="fa-solid fa-angle-down"></i> }</span>
      </div>
      {open && (
        <div className="dropdown-list">
          {styleList.map((style, idx) => (
            <div
              key={idx}
              className={`dropdown-option ${
                style.value === selected.value ? "active-f" : ""
              }`}
              onClick={() => {
                onSelect(style);
                setOpen(false);
              }}
            >
              <span className="icon">{style.icon}</span>
              <span class="text">{style.label}</span>
            </div>
          ))}
        </div>
      )} */}

    {/* <p className="apply-fonts-title">Apply Fonts</p> */}
    <p className="apply-fonts-title">Choose Style</p>

      <div className="font_family_set_container">
        {styleList.map((style, idx) => (
          <span
            key={idx}
            className={`ff_family position-relative ${selected?.value === style.value ? "active-f" : ""}`}
             onClick={() => handleFontSelect(style)}
      role="button"
      tabIndex={0}
      aria-label={`Apply ${style.label} font style`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleFontSelect(style);
        }
      }}
          >
            <span className="ff_icon">{style.icon}</span>
            <span className="family_text">{style.label.split(" ")[0]}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export  {CustomFontSelector};